import React, { useEffect } from 'react';

/**
 * ImageLightbox — pełnoekranowy podgląd zdjęcia (Terroir).
 * Zamknięcie: widoczny X (≥44px, touch-safe dla iPada), ESC, klik w tło. Blokada scrolla.
 * Użycie: <ImageLightbox image={{ src, alt, caption }} onClose={...} /> ; image=null → nie renderuje.
 */
export default function ImageLightbox({ image, onClose }) {
  useEffect(() => {
    if (!image) return;
    const onKey = (e) => { if (e.key === 'Escape') onClose?.(); };
    window.addEventListener('keydown', onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      window.removeEventListener('keydown', onKey);
      document.body.style.overflow = prev;
    };
  }, [image, onClose]);

  if (!image) return null;

  return (
    <div
      role="dialog"
      aria-modal="true"
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, zIndex: 200,
        background: 'rgba(15, 20, 16, 0.93)',
        backdropFilter: 'blur(6px)', WebkitBackdropFilter: 'blur(6px)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: 16,
      }}
    >
      <button
        type="button"
        onClick={onClose}
        aria-label="Zamknij podgląd"
        style={{
          position: 'absolute',
          top: 'max(12px, env(safe-area-inset-top, 0px))',
          right: 'max(12px, env(safe-area-inset-right, 0px))',
          width: 44, height: 44, borderRadius: 22,
          border: '1px solid var(--t-line-2)',
          background: 'rgba(15, 20, 16, 0.65)',
          color: 'var(--t-text)', fontSize: 26, lineHeight: 1,
          cursor: 'pointer', display: 'grid', placeItems: 'center', zIndex: 2,
        }}
      >×</button>

      <figure
        onClick={(e) => e.stopPropagation()}
        style={{
          margin: 0, maxWidth: '100%', maxHeight: '100%',
          display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12,
        }}
      >
        <img
          src={image.src}
          alt={image.alt || ''}
          style={{
            maxWidth: '100%',
            maxHeight: image.caption ? '80vh' : '90vh',
            objectFit: 'contain', borderRadius: 8,
            boxShadow: '0 24px 80px rgba(0,0,0,.5)',
          }}
        />
        {image.caption && (
          <figcaption style={{
            fontFamily: 'var(--t-mono)', fontSize: 11, letterSpacing: '.08em',
            textTransform: 'uppercase', color: 'var(--t-text-dim)', textAlign: 'center',
            maxWidth: 520,
          }}>{image.caption}</figcaption>
        )}
      </figure>
    </div>
  );
}
